// Function loadImageSlider loads the ImageSlider class by dynamically importing the js on demand if needed

export function loadImageSlider($parentEl, isList = false) {


	let $wg = $parentEl.querySelector('[data-wg="ImageSlider"]');

	if(!$wg) {
		// console.info('ImageSlider: no widget found');
		return Promise.reject('ImageSlider widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-image-slider-chunk" */ '../widgets/imageSlider').then(wg => {

		const { ImageSlider } = wg;


		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ImageSlider"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new ImageSlider($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ImageSlider($wg);
		}


	}).catch(error => error+'An error occurred while loading the ImageSlider widget');

}
